import { FaIcon, FaIcons } from '@innovationnorway/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OneWayInServiceDto } from 'src/api/v2';
import './WriteReferral.scss';
import { Card, Fieldset, Radio, Textarea, useRadioGroup } from '@innovationnorway/cl-react';

type Props = {
  referTo: string;
  selectedServices?: OneWayInServiceDto[];
  actorMessage: string;
  setActorMessage: (value: React.SetStateAction<string>) => void;
  customerEmailSelection: boolean;
  setCustomerEmailSelection: (value: React.SetStateAction<boolean>) => void;
  customerMessage: string;
  setCustomerMessage: (value: React.SetStateAction<string>) => void;
  formTitle: string;
  handlersName?: string;
  customerEmail?: string;
  customerName?: string;
  actorName: string;
};

const WriteReferral: React.FC<Props> = ({
  referTo,
  selectedServices,
  actorMessage,
  setActorMessage,
  customerEmailSelection,
  setCustomerEmailSelection,
  customerMessage,
  setCustomerMessage,
  formTitle,
  handlersName,
  customerEmail,
  customerName,
  actorName,
}) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { t: tCommon } = useTranslation('common');

  const { getRadioProps } = useRadioGroup({
    name: 'customerEmailSelection',
    onChange: (nextValue) =>
      nextValue === 'yes' ? setCustomerEmailSelection(true) : setCustomerEmailSelection(false),
    value: 'no',
  });

  return (
    <div>
      <div className="margin-left--3">
        <span>{tOneWayIn('referring.chosenActorForReferral')}</span>
        <ul className="margin-top--0">
          <li>{referTo}</li>
        </ul>
        {selectedServices!.length > 0 && (
          <>
            <span>{tOneWayIn('referring.selectedServices')}</span>
            <ul className="margin-top--0">
              {selectedServices!.map((service) => (
                <li key={service.id}>{service.name}</li>
              ))}
            </ul>
          </>
        )}
        <p className="margin-bottom--0 font-weight--bold">
          {tOneWayIn('referral.writeReferral.actorEmailDescription')}
        </p>
        <p className="margin-top--0">{tOneWayIn('referral.writeReferral.actorEmailExplainer')}</p>
        <Card className="email-preview">
          <div className="email-preview__header">
            <span>
              <FaIcon className="margin-right--1" name={FaIcons.EnvelopeLight} /> Ny henvisning i
              flerbedriftsportalen
            </span>
          </div>
          <p>
            Aktør <b>{referTo}</b>, har mottatt ny henvisning fra aktør <b>{actorName}</b>. Tittel på
            henvendelsen: <em>{formTitle}</em>. Gå til <b>flerbedriftsportal.no</b> for å følge opp
            kunden/henvendelsen.
          </p>
          <p>Melding fra {actorName}:</p>
          <Textarea value={actorMessage} onChange={(e) => setActorMessage(e.target.value)} maxLength={500} />
          <p>Med vennlig hilsen {handlersName}</p>
          <p>MERK: Svar til denne e-postadressen blir ikke behandlet</p>
        </Card>
      </div>
      <h3 className="padding-top--3 header--bold">{tOneWayIn('referral.writeReferral.toCustomer')}</h3>
      <div className="margin-left--3 stack-small">
        <Fieldset>
          <legend>{tOneWayIn('referral.writeReferral.customerEmailOption')}</legend>
          <Radio label={tCommon('yes')} {...getRadioProps('yes')} name="customerEmailSelection" />
          <Radio label={tCommon('no')} {...getRadioProps('no')} name="customerEmailSelection" />
        </Fieldset>

        {customerEmailSelection && (
          <div>
            <span>{tCommon('to')}:</span>
            <ul>
              <li>{customerEmail}</li>
            </ul>
            <p className="font-weight--bold">
              {tOneWayIn('referral.writeReferral.customerEmailDescription')}
            </p>
            <Card className="email-preview">
              <div className="email-preview__header">
                <span>
                  <FaIcon className="margin-right--1" name={FaIcons.EnvelopeLight} /> Informasjon om
                  henvisning
                </span>
              </div>
              <p>
                {customerName}, din henvendelse: <em>{formTitle}</em>, er henvist til {referTo}.
              </p>
              <p>Melding fra {actorName}:</p>
              <Textarea
                placeholder={tOneWayIn('referral.writeReferral.customerEmail.placeholder')}
                value={customerMessage}
                onChange={(e) => setCustomerMessage(e.target.value)}
                maxLength={500}
              />
              <p>Med vennlig hilsen {handlersName}</p>
              <p>MERK: Svar til denne e-postadressen blir ikke behandlet</p>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

export default WriteReferral;
